import { ParagraphText } from "../../../Libraries";
import { removeAllSpaces } from "../../../utils";
import styles from "./styles.module.css";

const AmountBox = ({ data, isNonIdeal }) => {

  return (
    <div className={`${styles.amountBoxWrapper} amountBoxWrapper`}>
      {data.map((item, index) => {
        return (
          <div className={`${styles.innerWrapper} amountBoxInnerWrapper`} key={index}>
            <ParagraphText
              className={`fontWeight400 fontSize14 newLightColor ${styles.firstPara}`}
              title={item.title}
              id={`${removeAllSpaces(item.id)}_label`}
            >
             {item.cirlceColor ? (
                <span
                  className={styles.circle}
                  style={{ background: item.cirlceColor }}
                />
              ) : null}
              <span className="truncate">{item.title}</span>
            </ParagraphText>

            <ParagraphText
              id={`${removeAllSpaces(item.id)}_value`}
              title={item.amount}
              className={`fontWeight500 fontSize20 truncate ${
                item.amountParaTextClassname
                  ? item.amountParaTextClassname
                  : isNonIdeal
                  ? "newFontColor"
                  : "newFontColor"
              }`}
            >
              {item.rsLabel && `Rs. `}
              <span className="truncate">
              {item.amount}
              </span>
              <span className="marginLeft5">
                {item.hasOwnProperty("value") ? `(${item.value})` : ""}
              </span>
            </ParagraphText>
          </div>
        );
      })}
    </div>
  );
};

export default AmountBox;
